import React from 'react'

import clsx from 'clsx'

import styles from './Typography.module.scss'

/** @type {import("./types").default} */
const Typography = ({ children, variant = 'body-sm', className, innerRef, component, ...rest }) => {
  const Component = component || 'p'

  return (
    <Component className={clsx('Typography', styles.root, styles[variant], className)} ref={innerRef} {...rest}>
      {children}
    </Component>
  )
}

export default Typography
